import Advice from './advice';
export default Advice;